import React from 'react'
import FloorSelectionbanner from '../../components/floorSelection/floorSelectionbanner'
import FloorSelectionbannermobile from '../../components/floorSelection/floorSelectionbannermobile'
import { isMobile } from "react-device-detect";
import Header from '../../shared/header'
import PagesFooter from '../../shared/pagesFooter'

const FloorSelectionPage = () => {
    return (
        <div>
        {console.log("device", isMobile)}
            <div className='floor-selection-header'>
                <Header />
            </div>
            {isMobile
            ?
            <FloorSelectionbannermobile />
          :
          <FloorSelectionbanner />

          }
            <PagesFooter />
        </div>
    )
}

export default FloorSelectionPage
